import { Avatar, Grid, Typography } from '@mui/material';
import { Equipment_Order_STATUSES, IEquipmentPrevOrderStatus } from 'API';
import { useIsDesktop } from 'Hooks';
import { StepIcon1, StepIcon2, StepIcon3, StepIcon4 } from 'Images';
import parse from 'html-react-parser';

interface IEquipmentStatusExtraInfoProps {
  stepStatus: IEquipmentPrevOrderStatus;
}

export const EquipmentStatusExtraInfo = ({
  stepStatus,
}: IEquipmentStatusExtraInfoProps) => {
  const isDesktop = useIsDesktop();

  const getIcon = (status: number) => {
    switch (status) {
      case Equipment_Order_STATUSES.created:
      case Equipment_Order_STATUSES.pending:
      case Equipment_Order_STATUSES.takenCareBySuperPharm:
        return (
          <Avatar
            src={StepIcon1}
            sx={{ width: '70px', height: '60px', mb: 2 }}
            alt=''
          />
        );
      case Equipment_Order_STATUSES.supplied:
      case Equipment_Order_STATUSES.finished:
        return (
          <Avatar
            src={StepIcon3}
            sx={{ width: '100px', height: '69px', mb: 2 }}
            alt=''
          />
        );
      case Equipment_Order_STATUSES.unknown:
        return (
          <Avatar
            src={StepIcon2}
            sx={{ width: '66px', height: '65px', mb: 2 }}
            alt=''
          />
        );
      case Equipment_Order_STATUSES.partialSupplied:
        return (
          <Avatar
            src={StepIcon4}
            sx={{ width: '85px', height: '58px', mb: 2 }}
            alt=''
          />
        );
    }
  };

  return (
    <Grid
      container
      direction={'column'}
      sx={{
        backgroundColor: 'primary.shade_50',
        border: '1px solid',
        borderColor: 'primary.shade_200',
        padding: isDesktop ? '40px 24px' : '24px 15px',
        borderRadius: '16px',
        alignItems: 'center',
        m: 0,
        maxWidth:
          stepStatus.mainStatus === Equipment_Order_STATUSES.finished
            ? '100%'
            : '600px',
        mb: '40px',
      }}
    >
      {getIcon(stepStatus.mainStatus)}
      {stepStatus.mainStatus === Equipment_Order_STATUSES.finished && (
        <Typography>{stepStatus.mainStatusLabel}</Typography>
      )}
      {parse(stepStatus.subStatusDescription || '')}
    </Grid>
  );
};
